<template>
  <div v-if="ready" class="product-purchase">
    <template v-if="disabled">
      <span class="product-purchase__unavailable">{{ unavailableText }}</span>
    </template>
    <template v-else>
      <product-purchase-tag
        v-bind="{
          product,
          listPriceTemplate,
          priceTemplate,
          singlePriceTemplate,
          installmentsTemplate,
          discountsTemplate,
          disabled,
        }"
      />
      <slot />
      <product-purchase-button v-bind="{ product, apiUrl, disabled, addToCartTagging }">{{
        buyText
      }}</product-purchase-button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductPurchaseTag from './product-purchase-tag/product-purchase-tag.vue';
import ProductPurchaseButton from './product-purchase-button/product-purchase-button.vue';

export default {
  name: 'product-purchase',
  components: {
    [ProductPurchaseTag.name]: ProductPurchaseTag,
    [ProductPurchaseButton.name]: ProductPurchaseButton,
  },
  props: {
    ean: {
      type: String,
      required: true,
    },
    addToCartTagging: {
      type: String,
      default: '',
    },
    apiUrl: {
      type: String,
      required: true,
    },
    buyText: {
      type: String,
      required: true,
    },
    unavailableText: {
      type: String,
      required: true,
    },
    listPriceTemplate: {
      type: String,
      required: true,
    },
    priceTemplate: {
      type: String,
      required: true,
    },
    singlePriceTemplate: {
      type: String,
      required: true,
    },
    installmentsTemplate: {
      type: String,
      required: true,
    },
    discountsTemplate: {
      type: String,
      required: true,
    },
  },
  computed: {
    product() {
      return this.products.find((product) => product.ean === this.ean);
    },
    disabled() {
      return !this.product || this.product.quantity <= 0;
    },
    ...mapGetters('cart', ['ready']),
    ...mapGetters('purchase', ['products']),
  },
  created() {
    this.$store.dispatch('purchase/created', {
      ean: this.ean,
    });
  },
  mounted() {
    this.$store.dispatch('purchase/mounted', {
      ean: this.ean,
      url: this.apiUrl,
    });
  },
};
</script>

<style lang="scss" src="./product-purchase.scss"></style>
